import { Component, Input, type OnInit } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { type User } from '@inside-hub-app/customer-portal-b2c-client'
import { NGXLogger } from 'ngx-logger'
import { DataService } from '../../../../services/data.service'

import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { CustomerPortalSharedModule } from '@inside-hub-app/customer-portal-shared'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { NgxGlideModule } from 'ngx-glide'
import { GoogleMapsModule } from '@angular/google-maps'
import { A11yModule } from '@angular/cdk/a11y'
import { TextFieldModule } from '@angular/cdk/text-field'
@Component({
  selector: 'customer-portal-app-navbar-expand',
  standalone: true,
  templateUrl: './navbar-expand.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomerPortalSharedModule,
    HubChildTranslateModule,
    NgxSkeletonLoaderModule,
    NgxGlideModule,
    GoogleMapsModule,
    A11yModule,
    TextFieldModule
  ]
})
export class NavbarExpandComponent implements OnInit {
  firstVehicleVin = ''
  user: User
  lang: string

  @Input()
    show: boolean

  constructor (
    public dataService: DataService,
    private readonly logger: NGXLogger,
    private readonly dialog: MatDialog
  ) {}

  ngOnInit (): void {
    this.dataService.onUserVehiclesLoaded.subscribe(vehicles => {
      if (vehicles?.length > 0) {
        this.firstVehicleVin = vehicles[0].vin
      }
    })
    this.dataService.onLanguageChange.subscribe(newLanguage => {
      this.lang = newLanguage.toUpperCase()
    })
    this.dataService.onUserLoaded.subscribe(user => {
      this.user = user
    })
  }
}
